import { Injectable, OnDestroy } from '@angular/core';
import { from, map, mergeMap, of, Subscription } from 'rxjs';
import { StorageService } from 'src/app/common/storage/storage.service';
import { UserService } from 'src/app/common/user/user.service';
import { v4 } from 'uuid';
import { CartCreateGQL, CartUpdateGQL } from './cart.mutation.generated';

@Injectable({ providedIn: 'root' })
export class CartService implements OnDestroy {
  uuidSubscription: Subscription = new Subscription();

  constructor(
    private localStorageService: StorageService,
    private cartUpdateGQL: CartUpdateGQL,
    private cartCreateGQL: CartCreateGQL,
    private userService: UserService,
  ) {}

  getCartUuid(generate = false, forceReturn = false) {
    return from(this.localStorageService.get('cart_uuid')).pipe(
      mergeMap(uuid_token => {
        const uuid = !this.userService.user || !generate ? uuid_token || (generate ? v4() : undefined) : undefined;
        if (uuid) {
          this.localStorageService.set('cart_uuid', uuid);
        }
        return this.cartCreateGQL.mutate({ input: { uuid } }).pipe(map(() => uuid));
      }),
      map(uuid => (!this.userService.user || forceReturn ? uuid : undefined)),
    );
  }

  getCart(generate = false, forceReturn = false) {
    return from(this.localStorageService.get('cart_uuid')).pipe(
      mergeMap(uuid_token => {
        const uuid = !this.userService.user || !generate ? uuid_token || (generate ? v4() : undefined) : undefined;
        if (uuid) {
          this.localStorageService.set('cart_uuid', uuid);
        }
        return this.cartCreateGQL.mutate({ input: { uuid } });
      }),
      map(r => (!this.userService.user || forceReturn ? r.data?.cartCreate : undefined)),
    );
  }

  mergeCart() {
    this.uuidSubscription = this.getCartUuid(false, true)
      .pipe(
        mergeMap(uuid_token => {
          if (uuid_token) {
            return this.cartUpdateGQL.mutate({ input: { uuid: uuid_token } });
          }
          return of(null);
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.uuidSubscription.unsubscribe();
  }
}
